RivalIQ.apps.Dashboard.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    widgets.Distribution = widgets.Chart.mixin({
        chartType: RivalIQ.graph.Distribution,

        loadData: function () {
            const me = this;

            return RivalIQ.data.companyData.fetch(me.getProps()).done(function (cd) {
                const groups = me.dashboardModel.getMetricGroups();
                me.groups = _.map(groups, function (group) {
                    return {
                        label: group.label,
                        metrics: _.map(group.metrics, function (concept) {
                            return new RivalIQ.models.Metric(concept, cd);
                        })
                    };
                });

                const trendKey = RivalIQ.enums.sourceDetails[me.getProp('source')].trendKey;
                me.dataWarning = _.get(cd, [
                    'compareData',
                    'companies',
                    0,
                    'periodSummary',
                    trendKey,
                    0,
                    'dataWarning'
                ]);
            });
        },

        // TODO change to new metric format
        getChartAttributes: function () {
            const me = this;

            const data = _.map(_.range(0, 2), function (i) {
                return _.map(me.groups, function (group) {
                    const metric = group.metrics[i];
                    return {
                        label: group.label,
                        value: metric.getValue({
                            format: false
                        }),
                        className: metric.getClassName(),
                        formatter: function () {
                            return metric.getValue({
                                format: true
                            });
                        }
                    };
                });
            });

            return {
                classNames: me.getChartClassName,
                data: data,
                height: me.getProp('height')
            };
        }

    });
});
